import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2400To2499Service {

  constructor() { }
}
